
export class HistoricalMovementType {

  constructor(
    public code?: number,
    public translate?: string
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/historical-movement-type.ts